<template>
    <div>
        <div class="container text-center">
            <div v-if="loading" class="pt-5 pb-5 gold-spinner mx-auto spinner-border" role="status" aria-label="Loading...">
                <span class="visually-hidden">Loading...</span>
            </div>
            <ErrorMessage v-if="errored" class="pt-5 pb-5"
                          :errorNotification="'We’re sorry that didn’t work. Please try again.'"></ErrorMessage>
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue'
    import ErrorMessage from '@/components/ErrorMessage.vue'

    const loading = ref(true)
    const errored = ref(false)

    // Add any logic you need in place of the old mounted() hook here
</script>

<style lang="scss" scoped>
    .container {
        height: 60vh;
    }

    .error-notification {
        height: unset;
    }
</style>